// extracted by mini-css-extract-plugin
export default {"container":"about_container__Rocx7","aboutImg":"about_aboutImg__prMtv","mainContainer":"about_mainContainer__KpEZl"};